
import React from 'react';
import { Link } from 'react-router-dom';

const Page404 = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center px-6 py-12">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-blue-600">404</h1>
        <h2 className="text-6xl font-medium py-8">Oops! Page not found</h2>
        <p className="text-2xl pb-8 px-12 font-medium">
          The page you are looking for does not exist. It might have been moved
          or deleted.
        </p>
        <Link
          to="/"
          className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-md transition duration-300 ease-in-out"
        >
          Go Home
        </Link>
      </div>
    </div>
  );
};

export default Page404;
